/**
 * Calculator add-to-cart: single-item forms, dose-aware kit syringe, and
 * "Add these supplies" (AJAX cart + open the existing cart drawer).
 *
 * syringeSizeForVolume / announceCalcResult are kept in sync with
 * assets/is-calc-kit-logic.js (tested there).
 */

var CALC_RESULT_EVENT = 'is-calc:result';
var SYRINGE_SIZE_THRESHOLD_ML = 0.5;
var DRAWER_SECTION_ID = 'is-cart-drawer';

function syringeSizeForVolume(volumeMl, threshold) {
  if (threshold == null) threshold = SYRINGE_SIZE_THRESHOLD_ML;
  if (!Number.isFinite(volumeMl) || volumeMl <= 0) return null;
  return volumeMl <= threshold ? 'small' : 'large';
}

function announceCalcResult(volumeMl) {
  var ready = Number.isFinite(volumeMl) && volumeMl > 0;
  document.dispatchEvent(new CustomEvent(CALC_RESULT_EVENT, {
    bubbles: true,
    detail: { volumeMl: ready ? volumeMl : null, ready: ready },
  }));
}

window.announceCalcResult = announceCalcResult;

function setButtonBusy(button, busy, busyLabel) {
  if (!button) return;
  if (busy) {
    if (!button.dataset.originalLabel) button.dataset.originalLabel = button.textContent.trim();
    button.disabled = true;
    if (busyLabel) button.textContent = busyLabel;
  } else {
    button.disabled = false;
    if (button.dataset.originalLabel) button.textContent = button.dataset.originalLabel;
  }
}

function announceLive(kit, message) {
  if (!kit) return;
  var live = kit.querySelector('[data-calc-kit-live]');
  if (live) live.textContent = message;
}

function visibleKitItems(kit) {
  return Array.prototype.filter.call(kit.querySelectorAll('.calc-kit__item'), function (item) {
    return !item.hidden && item.getAttribute('data-variant-id');
  });
}

function applySyringeSize(kit, size) {
  var items = kit.querySelectorAll('.calc-kit__item[data-kit-role="syringe"]');
  if (!items.length) return;
  var note = kit.querySelector('[data-calc-kit-note]');
  items.forEach(function (item) {
    var itemSize = item.getAttribute('data-kit-size');
    item.hidden = !(itemSize === 'both' || !size || itemSize === size);
  });
  if (note) {
    if (size === 'small') {
      note.textContent = 'Suggested syringe: 0.5 mL, to match this draw.';
      note.hidden = false;
    } else if (size === 'large') {
      note.textContent = 'Suggested syringe: 1 mL, to match this draw.';
      note.hidden = false;
    } else {
      note.textContent = '';
      note.hidden = true;
    }
  }
}

function setStickyVisible(show) {
  document.querySelectorAll('[data-calc-kit-sticky]').forEach(function (bar) {
    bar.hidden = !show;
  });
}

function morphCartDrawer(html) {
  if (!html) return;
  var drawerRoot = document.querySelector('cart-drawer-component[class~="cart-drawer"]');
  if (!drawerRoot) return;
  var tmp = document.createElement('div');
  tmp.innerHTML = html.trim();
  var freshInner = tmp.querySelector('.cart-drawer__inner');
  var currentInner = drawerRoot.querySelector('.cart-drawer__inner');
  if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
}

function openCartDrawer() {
  var drawerRoot = document.querySelector('cart-drawer-component[class~="cart-drawer"]');
  if (!drawerRoot) return;
  if (typeof drawerRoot.open === 'function') {
    drawerRoot.open();
    return;
  }
  var dlg = drawerRoot.querySelector('dialog');
  if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
}

function updateCartBadge(count) {
  var badge = document.querySelector('[data-cart-count]');
  if (badge) {
    badge.textContent = count;
    badge.classList.toggle('is-empty', count === 0);
  }
  var cartIcon = document.querySelector('cart-icon-component');
  if (cartIcon && typeof cartIcon.updateCartCount === 'function') {
    cartIcon.updateCartCount(count);
  }
}

function addItemsToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: items,
      sections: DRAWER_SECTION_ID,
      sections_url: window.location.pathname,
    }),
  }).then(function (response) {
    if (!response.ok) throw new Error('HTTP ' + response.status);
    return response.json();
  }).then(function (data) {
    if (data && data.sections && data.sections[DRAWER_SECTION_ID]) {
      morphCartDrawer(data.sections[DRAWER_SECTION_ID]);
    }
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: data, sourceId: 'calc-kit', data: { source: 'calculator' } },
    }));
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartBadge(cart.item_count);
      return { data: data, cart: cart, count: items.length };
    });
  });
}

function itemsFromKit(kit) {
  return visibleKitItems(kit).map(function (item) {
    return { id: Number(item.getAttribute('data-variant-id')), quantity: 1 };
  }).filter(function (item) { return item.id > 0; });
}

function kitFromEventTarget(target) {
  return (target && target.closest) ? (target.closest('[data-calc-kit]') || document.querySelector('[data-calc-kit]')) : document.querySelector('[data-calc-kit]');
}

document.addEventListener(CALC_RESULT_EVENT, function (event) {
  var detail = event.detail || {};
  var kit = document.querySelector('[data-calc-kit]');
  if (!kit) return;
  var threshold = parseFloat(kit.getAttribute('data-size-threshold')) || SYRINGE_SIZE_THRESHOLD_ML;
  var size = detail.ready ? syringeSizeForVolume(detail.volumeMl, threshold) : kit.getAttribute('data-default-size');
  applySyringeSize(kit, size);
  setStickyVisible(!!detail.ready);
});

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-calc-add-all]');
  if (!button) return;
  event.preventDefault();
  var kit = kitFromEventTarget(button) || document.querySelector('[data-calc-kit]');
  if (!kit) return;
  var items = itemsFromKit(kit);
  if (!items.length) {
    announceLive(kit, 'No in-stock supplies to add.');
    return;
  }
  var buttons = document.querySelectorAll('[data-calc-add-all]');
  buttons.forEach(function (btn) { setButtonBusy(btn, true, 'Adding…'); });
  announceLive(kit, 'Adding suggested supplies to cart.');
  addItemsToCart(items).then(function (result) {
    var noun = result.count === 1 ? 'item' : 'items';
    announceLive(kit, 'Added ' + result.count + ' ' + noun + ' to cart.');
    buttons.forEach(function (btn) {
      btn.disabled = false;
      btn.textContent = 'Added';
      setTimeout(function () {
        if (btn.dataset.originalLabel) btn.textContent = btn.dataset.originalLabel;
      }, 1600);
    });
    openCartDrawer();
  }).catch(function () {
    announceLive(kit, 'Could not add those supplies. Try adding them one at a time.');
    buttons.forEach(function (btn) { setButtonBusy(btn, false); });
  });
});

document.addEventListener('submit', function (event) {
  var form = event.target.closest('[data-calc-add]');
  if (!form) return;

  event.preventDefault();

  var button = form.querySelector('button[type="submit"]');
  var kit = form.closest('[data-calc-kit]');
  var variantId = form.querySelector('[name="id"]');
  if (!variantId || !variantId.value) return;

  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  }

  addItemsToCart([{ id: Number(variantId.value), quantity: 1 }]).then(function () {
    if (kit) announceLive(kit, 'Added to cart.');
    openCartDrawer();
    if (button) {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }).catch(function () {
    if (kit) announceLive(kit, 'Could not add that item. Try again.');
    if (button) {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });
});
